import React from 'react';
import PageHeader from '../components/PageHeader';
import AskErpChat from '../components/AskErpChat';

export default function AskERP() {
  return (
    <div className="p-6 md:p-8 h-full flex flex-col">
      <PageHeader
        overline="AI Assistant"
        title="Ask ERP"
        subtitle="Powered by Ellora AI · grounded on your live ERP data"
      />
      <div className="flex-1 min-h-0">
        <AskErpChat />
      </div>
    </div>
  );
}
